function PageClass(aName, aPermissionId, aHash) {
    this.Name = aName;
    this.PermissionId = aPermissionId;
    this.Hash = aHash;
}
if (typeof exports !== 'undefined') {
    module.exports = PageClass;
}